import $foreign from "./foreign.cjs";
var unit = $foreign.unit;
export { unit };
